import {z} from 'zod';

import {BigDecimalSchema, CurrencySchema} from './Price';

export const MoneySchema = z.object({
  amount: BigDecimalSchema,
  currency: CurrencySchema,
});
export type Money = z.infer<typeof MoneySchema>;
